import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Share.css';

function Share() {
  const [searchParams] = useSearchParams();
  const [noteData, setNoteData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const noteParam = searchParams.get('note');

    if (!noteParam) {
      setError('Not verisi bulunamadı');
      return;
    }

    try {
      // Base64 decode
      const decodedData = atob(noteParam);
      // JSON parse
      const parsedData = JSON.parse(decodedData);
      setNoteData(parsedData);

      // 1.5 saniye sonra deep link'i tetikle
      setTimeout(() => {
        window.location.href = `derkenar://share?note=${noteParam}`;
      }, 1500);
    } catch (err) {
      setError('Not verisi geçersiz');
      console.error('Decode error:', err);
    }
  }, [searchParams]);

  if (error) {
    return (
      <div className="share-container">
        <div className="share-error">
          <h2>Hata</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!noteData) {
    return (
      <div className="share-container">
        <div className="share-loading">
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="share-container">
      <div className="share-content">
        <div className="share-header">
          <h1>Derkenar</h1>
          <p>Paylaşılan Not</p>
        </div>

        <div className="note-preview">
          {noteData.bookTitle && (
            <div className="note-field">
              <label>Kitap</label>
              <p className="book-title">{noteData.bookTitle}</p>
            </div>
          )}

          {noteData.quote && (
            <div className="note-field">
              <label>Alıntı</label>
              <p className="quote">"{noteData.quote}"</p>
            </div>
          )}

          {noteData.note && (
            <div className="note-field">
              <label>Yorum</label>
              <p className="note-text">{noteData.note}</p>
            </div>
          )}

          {noteData.author && (
            <div className="note-field">
              <label>Yazar</label>
              <p>{noteData.author}</p>
            </div>
          )}
        </div>

        <div className="app-download">
          <p className="download-text">Uygulamayı indirerek tüm notlarınızı görüntüleyin</p>

          <div className="store-buttons">
            <a
              href="https://apps.apple.com/app/derkenar"
              target="_blank"
              rel="noopener noreferrer"
              className="store-button app-store"
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="App Store'dan İndir"
              />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.derkenar"
              target="_blank"
              rel="noopener noreferrer"
              className="store-button play-store"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Google Play'den İndir"
              />
            </a>
          </div>
        </div>

        <div className="redirect-info">
          <p>Uygulama açılıyor...</p>
        </div>
      </div>
    </div>
  );
}

export default Share;
